import React, { useState, Fragment } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import Logo from '../../images/gattomioNero.png';
import paws8 from '../../images/paws-8.png';
import paws10 from '../../images/paws-10.png';
import { forgotPassword } from '../../api/backend';
import '../LoginPage/AuthPage.scss';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const validate = () => {
    if (!email) {
      setEmailError('Email obbligatoria');
      return false;
    }
    if (!/\S+@\S+\.\S+/.test(email)) {
      setEmailError('Email non valida');
      return false;
    }
    setEmailError('');
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);
    try {
      await forgotPassword(email);
      setSent(true);
    } catch (err) {
      // Risposta generica: mostriamo sempre "inviato" per sicurezza
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Fragment>
      <Navbar hclass={'wpo-site-header'} Logo={Logo} />
      <PageTitle pageTitle={'Password dimenticata'} pagesub={'Recupero account'} />

      <section className="wpo-auth-section section-padding">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 col-xl-9">

              <div className="auth-wrapper">
                {/* Left decorative panel */}
                <div className="auth-side-panel">
                  <div className="side-panel-content">
                    <div className="side-panel-icon">
                      <img src={paws8} alt="Petlox paw" />
                    </div>
                    <h3>Recupera il tuo account</h3>
                    <p>
                      Inserisci la tua email e ti invieremo un link
                      per reimpostare la password in pochi secondi.
                    </p>
                    <Link to="/login" className="side-panel-btn">
                      Torna al login
                    </Link>
                  </div>
                </div>

                {/* Right form panel */}
                <div className="auth-form-panel">
                  {sent ? (
                    <div className="auth-success-state">
                      <div className="auth-success-icon">
                        <i className="ti-email"></i>
                      </div>
                      <h2>Email inviata!</h2>
                      <p>
                        Se <strong>{email}</strong> è registrata, riceverai a breve
                        un'email con il link per reimpostare la password.
                      </p>
                      <p className="auth-success-note">
                        Controlla anche la cartella spam se non la trovi nella inbox.
                      </p>
                      <Link to="/login" className="theme-btn auth-success-btn">
                        Torna al login
                      </Link>
                    </div>
                  ) : (
                    <>
                      <div className="auth-form-header">
                        <span className="auth-subtitle">Recupero account</span>
                        <h2>Password dimenticata?</h2>
                        <p>Inserisci la tua email per ricevere il link di reset</p>
                      </div>

                      <form className="auth-form" onSubmit={handleSubmit} noValidate>
                        <div className="form-group">
                          <label>Email</label>
                          <div className="input-wrapper">
                            <input
                              type="email"
                              name="email"
                              className={emailError ? 'is-invalid' : ''}
                              value={email}
                              onChange={(e) => {
                                setEmail(e.target.value);
                                if (emailError) setEmailError('');
                              }}
                              placeholder="la-tua@email.com"
                              autoComplete="email"
                            />
                            <i className="ti-email field-icon"></i>
                          </div>
                          {emailError && <div className="invalid-feedback">{emailError}</div>}
                        </div>

                        <div className="submit-area">
                          <button type="submit" className="theme-btn" disabled={loading}>
                            {loading ? (
                              <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Invio in corso...
                              </>
                            ) : 'Invia link di reset'}
                          </button>
                        </div>
                      </form>

                      <div className="auth-divider">
                        <span>oppure</span>
                      </div>

                      <div className="auth-switch-link">
                        <p>
                          Ricordi la password?{' '}
                          <Link to="/login">Accedi ora</Link>
                        </p>
                      </div>
                    </>
                  )}
                </div>
              </div>

              <img src={paws8} alt="" className="paw-decoration paw-top-right" />
              <img src={paws10} alt="" className="paw-decoration paw-bottom-left" />

            </div>
          </div>
        </div>
      </section>

      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default ForgotPasswordPage;
